import React from "react";
import "./Cards.css";
import Card from "../Card/Card";
import { useDashboardData } from "../../Data/Data";

const Cards = () => {
  const cardsData = useDashboardData() || []; 

  if (cardsData.length === 0) {
    return <p>Loading cards...</p>;
  }

  return (
    <>
      {cardsData.map((card, id) => (
        <Card
          key={id}
          title={card.title}
          color={card.color}
          png={card.png}
          series={card.series}
        />
      ))}
    </>
  );
};

export default Cards;